import React from "react";
import PropTypes from "prop-types";

import moment from "moment";

import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.scss";

import { Calendar, Views, momentLocalizer } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";

import { useHistory } from "react-router-dom";

const localizer = momentLocalizer(moment);

const DragAndDropCalendar = withDragAndDrop(Calendar);

const FORMATS = {
  timeGutterFormat: "HH:mm",
  eventTimeRangeFormat: ({ start, end }, culture, local) =>
    `${local.format(start, "HH:mm", culture)} – ${local.format(
      end,
      "HH:mm",
      culture
    )}`
};
const ResourceScheduler = ({
  defaultDate,
  step,
  resources,
  events,
  onMoveEvent,
  ...props
}) => {
  const history = useHistory();

  const dblClickEvent = event =>
    history.push(`/dispatch/orders/${event.id}/summary`);

  return (
    <div>
      <DragAndDropCalendar
        date={moment(defaultDate).toDate()}
        defaultView={Views.DAY}
        events={events}
        formats={FORMATS}
        localizer={localizer}
        resizable={false}
        resourceIdAccessor="resourceId"
        resourceTitleAccessor="resourceTitle"
        resources={resources}
        selectable={false}
        step={step}
        timeslots={1}
        toolbar={false}
        // onEventResize={onResizeEvent}
        views={["day"]}
        onDoubleClickEvent={dblClickEvent}
        onEventDrop={onMoveEvent}
        // selected={null}
        onNavigate={() => {}}
        {...props}
      />
    </div>
  );
};
ResourceScheduler.propTypes = {
  resources: PropTypes.array,
  events: PropTypes.array,
  defaultDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
    PropTypes.instanceOf(moment)
  ]),
  step: PropTypes.number,
  onMoveEvent: PropTypes.func
};

ResourceScheduler.defaultProps = {
  resources: [
    { resourceId: 1, resourceTitle: "Bay #1" },
    { resourceId: 2, resourceTitle: "Bay #2" },
    { resourceId: 3, resourceTitle: "Bay #3" },
    { resourceId: 4, resourceTitle: "Bay #4" }
  ],
  events: [
    {
      id: 0,
      title: "EVE/ACUSHNET",
      start: "2018-09-11T14:00:00.000Z",
      end: "2018-09-11T18:00:00.000Z",
      resourceId: 1
    },
    {
      id: 1,
      title: "EVE/ACUSHNET",
      start: "2018-09-11T13:30:00.000Z",
      end: "2018-09-11T14:30:00.000Z",
      resourceId: 1
    },
    {
      id: 2,
      title: "EVE/ACUSHNET",
      start: "2018-09-11T13:30:00.000Z",
      end: "2018-09-11T14:30:00.000Z",
      resourceId: 1
    },
    {
      id: 3,
      title: "EVE/ACUSHNET",
      start: "2018-09-11T14:00:00.000Z",
      end: "2018-09-11T15:00:00.000Z",
      resourceId: 1
    }
  ]
};
export default ResourceScheduler;
